import { SxProps, Theme } from '@mui/material';

const chip: SxProps<Theme> = {
  // The theme's chip is display:flex, which fills the line. In a message these
  // sit mid-sentence and have to flow with the words around them.
  display: 'inline-flex',
  verticalAlign: 'middle',
  maxWidth: '100%',
  '& .MuiChip-label': {
    fontWeight: 400,
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap'
  },
  '& .MuiChip-deleteIcon': {
    fontSize: '16px',
    '& svg': { fontSize: '16px' }
  }
};

// The theme maps error to its light shade for outlined chips, and pins the
// delete icon colour with !important.
const excludeChip: SxProps<Theme> = {
  color: 'error.main',
  borderColor: 'error.main',
  '& .MuiChip-deleteIcon': {
    color: (theme: Theme) => `${theme.palette.error.main} !important`
  }
};

const withMaxWidth = (maxWidth: number) => ({ maxWidth });

// Laid out as text, so a long label runs on to the next line instead of being
// cut off; only the first and last lines close the pill. White, not the
// outlined chip's transparent, so an Or group's shading stays outside it.
const wrapping: SxProps<Theme> = {
  display: 'inline',
  backgroundColor: 'common.white',
  height: 'auto',
  fontSize: '14px',
  lineHeight: '20px',
  boxDecorationBreak: 'slice',
  WebkitBoxDecorationBreak: 'slice',
  '& .MuiChip-label': {
    display: 'inline',
    whiteSpace: 'normal',
    overflow: 'visible',
    overflowWrap: 'anywhere'
  },
  '& .MuiChip-deleteIcon': {
    verticalAlign: 'middle',
    ml: '4px'
  }
};

const prefix: SxProps<Theme> = { fontWeight: 700 };

export const candidateProfileChipSx = {
  chip,
  excludeChip,
  withMaxWidth,
  wrapping,
  prefix
};
